import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';



import CustomEditor from 'components/base/CustomEditor';
import ErrorFieldMessage, {
  hasErrorFromList,
} from 'components/base/ErrorFieldMessage';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import {
  CustomTitleWithDropDown,
  CustomTitleWithDropDownAndInput,
} from 'components/customer/CustomTitleWithDropDown';
import { EditCustomerHandleError } from 'components/customer/EditCustomerHandleError';
import AdjustValidationResult from 'components/customerDetail/AdjustValidationResult';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { PermissionCodes } from 'config/PermissionCodes';
import { TRANSACTION_RECORD_TYPE } from 'containers/record/records/TransactionList';

import './AdjustValidationResult.scss';



import CloseIcon from '../../assets/images/prompt_close_icon.svg';
import { tierTypeConfig } from 'config/TierTypeConfig';


const UpdatePointsModal = ({
  user,
  customer,
  errors,
  show,
  setShow,
  allTransactionList,
  adjustPointValidationResult,
  adjustTpeValidationResult,
}) => {
  const dispatch = useDispatch();

  const [pointTransaction, setPointTransaction] = useState(null);
  const [transactionPoint, setTransactionPoint] = useState(null);
  const [tpeTransaction, setTpeTransaction] = useState(null);
  const [transactionTpe, setTransactionTpe] = useState(null);
  const [pointTransactionRemark, setPointTransactionRemark] = useState(null);
  const [transaction, setTransaction] = useState();
  const [showAddConfirm, setShowAddConfirm] = useState(false);

  const [errorList, setErrorList] = useState([]);

  const getPointTransactionSource = () => {
    let source = [];
    const permissions = user.userPermissions;
    if (permissions.includes(PermissionCodes.adjustAllRewards)) {
      source.push({ name: 'Add transaction', pk: 'ADD_POINTS' });
      source.push({ name: 'Remove transaction', pk: 'REMOVE_POINTS' });
    }
    return source;
  };

  const onClose = () => {
    if (showAddConfirm) {
      setShowAddConfirm(false);
      return;
    }
    setShow(false);
  };

  const updateCustomerPoint = () => {
    dispatch({
      type: 'customerList/updateCustomerPoint',
      payload: {
        data: {
          ...customer,
          pointTransaction,
          transactionPoint,
          tpeTransaction,
          transactionTpe,
          pointTransactionRemark,
          transaction,
        },
        customer: customer,
        refreshCustomer: true,
      },
    });
  };

  const saveAction = () => {
    if (showAddConfirm) {
      updateCustomerPoint();
      return;
    }

    const error = [];
    if (
      !pointTransaction?.value &&
      !transactionPoint &&
      !tpeTransaction?.value &&
      !transactionTpe
    ) {
      error.push({
        name: 'transaction',
      });
    } else {
      if (!pointTransaction?.value && transactionPoint) {
        error.push({
          name: 'pointTransaction',
        });
      }
      if (!transactionPoint && pointTransaction?.value) {
        error.push({
          name: 'transactionPoint',
        });
      }

      if (!tpeTransaction?.value && transactionTpe) {
        error.push({
          name: 'tpeTransaction',
        });
      }
      if (!transactionTpe && tpeTransaction?.value) {
        error.push({
          name: 'transactionTpe',
        });
      }
    }
    console.log(error);
    if (error.length) {
      setErrorList(error);
      return;
    }

    const customerId = customer?.pk;
    let points = 0;
    let tpe = 0;

    if (
      pointTransaction?.value === 'ADD_POINTS' &&
      Number(transactionPoint) > 0
    ) {
      points = Number(transactionPoint);
    }
    if (tpeTransaction?.value === 'ADD_POINTS' && Number(transactionTpe) > 0) {
      tpe = Number(transactionTpe);
    }

    if (Number(points) > 0 || Number(tpe) > 0) {
      dispatch({
        type: 'createPointRecord/adjustPointValidation',
        payload: {
          customerId,
          points,
          tpe,
          validationFailure: () => setShowAddConfirm(true),
          validationSuccess: () => updateCustomerPoint(),
        },
      });
    } else {
      updateCustomerPoint();
    }
  };

  useEffect(() => {
    if (show) {
      dispatch({
        type: 'customerList/updateState',
        payload: {
          errorsList: [],
        },
      });
      setPointTransaction(null);
      setTransactionPoint(null);
      setTpeTransaction(null);
      setTransactionTpe(null);
      setPointTransactionRemark(null);
      setTransaction();
      setShowAddConfirm(false);
    }
  }, [show]);
  console.log(
    '@@163: errorList: ',
    errorList,
    hasErrorFromList(errorList, EditCustomerHandleError.transaction.name),
    EditCustomerHandleError.transaction.name,
  );
  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className={`base-prompt-container customer-detail-prompt`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className="customer-detail-modal-title">
          {showAddConfirm ? 'Reminder' : 'Adjust points & progression points'}
        </label>

        <div
          className={
            showAddConfirm ? 'customer-detail-prompt-content-hidden' : ''
          }
        >
          <CustomTitleWithDropDownAndInput
            title="Adjust points"
            source={getPointTransactionSource()}
            defaultValue={''}
            needFilter={false}
            unit="Points"
            customClass="edit-custom-transaction-selector customer-detail-prompt-selector"
            setValue={(value) => {
              setPointTransaction(value);
            }}
            setInputValue={(value) => {
              setTransactionPoint(value);
            }}
          />
          <ErrorFieldMessage
            id={EditCustomerHandleError.pointTransaction.name}
            error={hasErrorFromList(
              errorList,
              EditCustomerHandleError.pointTransaction.name,
            )}
            message={EditCustomerHandleError.pointTransaction.message}
          />
          <ErrorFieldMessage
            id={EditCustomerHandleError.transactionPoint.name}
            error={hasErrorFromList(
              errorList,
              EditCustomerHandleError.transactionPoint.name,
            )}
            message={EditCustomerHandleError.transactionPoint.message}
          />

          {
            tierTypeConfig.levels && (
              <>
                <CustomTitleWithDropDownAndInput
                  title="Adjust progression points"
                  source={getPointTransactionSource()}
                  defaultValue={''}
                  needFilter={false}
                  unit="Progression Points"
                  customClass="edit-custom-transaction-selector customer-detail-prompt-selector"
                  setValue={(value) => {
                    setTpeTransaction(value);
                  }}
                  setInputValue={(value) => {
                    setTransactionTpe(value);
                  }}
                />
                <ErrorFieldMessage
                  id={EditCustomerHandleError.tpeTransaction.name}
                  error={hasErrorFromList(
                    errorList,
                    EditCustomerHandleError.tpeTransaction.name,
                  )}
                  message={EditCustomerHandleError.tpeTransaction.message}
                />
                <ErrorFieldMessage
                  id={EditCustomerHandleError.transactionTpe.name}
                  error={hasErrorFromList(
                    errorList,
                    EditCustomerHandleError.transactionTpe.name,
                  )}
                  message={EditCustomerHandleError.transactionTpe.message}
                />
              </>
            )
          }

          <ErrorFieldMessage
            id={EditCustomerHandleError.transaction.name}
            error={hasErrorFromList(
              errorList,
              EditCustomerHandleError.transaction.name,
            )}
            message={
              tierTypeConfig.levels
              ? EditCustomerHandleError.transaction.message
              : EditCustomerHandleError.transaction.messageWithoutLevel
            }
          />

          <CustomTitleWithDropDown
            // customClass={'filter-title'}
            title={'Related transaction (optional)'}
            source={allTransactionList}
            placeholder={'Search by Transaction ID,  Invoice ID'}
            labelContainPk
            defaultValue={transaction}
            setValue={(v) => {
              setTransaction(v);
            }}
            loadMoreAction={'transactions/getCurrentPageTransactions'}
            // customFilter={customFilter}
            filterAction={'transactions/getCurrentPageTransactions'}
            defaultFilter={{
              isSelectorLoad: true,
              ssoUid: customer.ssoUid,
              rank: true,
              searchField: 'searchIdOrInvoiceId',
            }}
            customItem={(item) => {
              return `Transaction ID: ${item.pk}`;
            }}
            showItemDescription
            customItemDescription={(item) => {
              return `Invoice ID: ${
                (item.transactionDisplayType ===
                TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_POS
                  ? item.posInvoiceId
                  : item.invoiceId) || '-'
              }`;
            }}
          />

          <CustomTitleLabel title="Admin remarks (optional)" />
          <CustomEditor
            initialValue={''}
            onValueChange={(value) => {
              setPointTransactionRemark(value);
            }}
            onFocus={() => {}}
            errorMessage={''}
            error={''}
          />
        </div>

        {showAddConfirm && adjustPointValidationResult ? (
          <AdjustValidationResult
            adjustValidationResult={adjustPointValidationResult}
          />
        ) : null}
        {showAddConfirm && adjustTpeValidationResult ? (
          <AdjustValidationResult
            adjustValidationResult={adjustTpeValidationResult}
          />
        ) : null}

        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title="Cancel"
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title="Confirm"
            action={saveAction}
            requires={PermissionCodes.changeCustomer}
            type={BUTTON_TYPES.main}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapPropsToState = (state) => ({
  user: state.users,
  customer: state.customerList.customer,
  errors: state.customerList.errorsList,
  allTransactionList: state.transactions.allTransactionList,
  adjustPointValidationResult:
    state.createPointRecord.adjustPointValidationResult,
  adjustTpeValidationResult: state.createPointRecord.adjustTpeValidationResult,
});

export default connect(mapPropsToState)(UpdatePointsModal);
